import { render } from "./CreationForm.vue?vue&type=template&id=6aebaec4&scoped=true"
import script from "./CreationForm.vue?vue&type=script&lang=js"
export * from "./CreationForm.vue?vue&type=script&lang=js"

import "./CreationForm.vue?vue&type=style&index=0&id=6aebaec4&lang=scss&scoped=true"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aebaec4"]])

export default __exports__